module.exports = __webpack_public_path__ + "static/media/foto_cadi_0001.8b5071bd.jpg";